import { Field } from '@fluentui/react-components';
import TenantPicker from './TenantPicker';
import type { GetTenantsFn, ITenantLike } from './types';

export interface TenantSelectorFieldProps {
  getTenants: GetTenantsFn;
  tenantId?: number;
  tenantName?: string;
  onSelected: (tenant: ITenantLike) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  placeholder?: string;
}

const TenantSelectorField = ({
  getTenants,
  tenantId,
  tenantName,
  onSelected,
  label = 'Tenant',
  required,
  disabled,
  errorMessage,
  placeholder,
}: TenantSelectorFieldProps) => (
  <Field
    label={label}
    required={required}
    validationMessage={errorMessage}
    style={{ width: '100%', maxWidth: 520 }}
  >
    <TenantPicker
      getTenants={getTenants}
      tenantId={tenantId}
      tenantName={tenantName}
      onSelected={onSelected}
      disabled={disabled}
      placeholder={placeholder}
      ariaLabel={`Pick ${label.toLowerCase()}`}
    />
  </Field>
);

export default TenantSelectorField;
